import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { Loader } from '../../../shared-components';
import { 
  LOADING_MODAL_I18N_KEYS as MY_I18N_KEYS, 
  LOADING_MODAL_I18N_PREFIX as MY_I18N_PREFIX 
} from '../constants/i18n/LoadingModali18nConstants';

class LoadingModal extends Component {
  static propTypes = {
    show:                                                    PropTypes.bool.isRequired,
    clearUploadedFileAndReturnToUploadFilesOrEditTopicModal: PropTypes.func.isRequired,
    uploadedFileName:                                        PropTypes.string.isRequired
  };

  componentDidMount() {
    if (this.props.show) {
      document.body.classList.add('modal-open');
    }
  }

  getI18nText(textKey) {
    return t(MY_I18N_PREFIX + "." + textKey);
  }

  render() {
    const { 
      show, 
      clearUploadedFileAndReturnToUploadFilesOrEditTopicModal ,
      uploadedFileName
    } = this.props;

    return (
      <div className={`modal create-upload-data-topic-modal loading-modal ${show ? 'modal-show' : 'modal-hide'}`}>
        <div className="loading-modal-dialog">
          <div className="loading-modal-content">
            <div className="loading-modal-header">
              <span className="uploading-modal-title">
                {this.getI18nText(MY_I18N_KEYS.uploading)}
              </span>
            </div>
            <div className="uploading-modal-body">
              <span className="uploading-file-name">
                {uploadedFileName}
              </span>
              <div className="loading-icon">
                <Loader/>
              </div>
            </div>
            <div className="uploading-modal-footer">
              <button 
                className="cancel-upload-button" 
                onClick={clearUploadedFileAndReturnToUploadFilesOrEditTopicModal}
              >
                {this.getI18nText(MY_I18N_KEYS.cancel)}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LoadingModal;




// WEBPACK FOOTER //
// ./src/features/topics/components/file-upload/LoadingModal.js